import { useSyncExternalStore } from "react";
import { genieTools, type GenieToolDefinition } from "./tool-registry";

export function useGenieToolDefinitions(): GenieToolDefinition[] {
  return useSyncExternalStore(genieTools.subscribe, genieTools.getSnapshot);
}
